import React, { useCallback, useEffect, useState } from "react";

import html2canvas from "html2canvas";
import * as html2pdf from "html2pdf.js";

import { generateCreditNote } from "services";

import { recordPageView, useCancelAsyncOnUnmount, useParams, useTranslation } from "utils";

import { Button, Col, Icon, MainPage, Message, Row } from "components";

const CreditNote = () => {
  const { t } = useTranslation(["meta"]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(false);
  const [note, setNote] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  const { token } = useParams();

  const share = {
    title: t("meta:creditNote.title"),
    summary: t("meta:creditNote.description"),
    link: `${process.env.REACT_APP_FARM_URL}/sign-up`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  };

  const generatePdf = useCallback(async () => {
    try {
      const container = document.getElementById("pdfContainer");
      if (data && container) {
        const footers = container.getElementsByClassName("pdf-foot");
        const footerCanvas = await html2canvas(footers[0]);
        const footerImage = footerCanvas.toDataURL();
        const footerClone = footers[0].cloneNode(true);
        footers[0].remove();

        const opt = {
          margin: [0, 0, 50, 0],
          filename: `${note}.pdf`,
          image: {
            type: "jpeg",
            quality: 0.98,
          },
          jsPDF: {
            unit: "mm",
            orientation: "portrait",
            format: "a4",
          },
          pagebreak: { before: ".break-page" },
        };

        html2pdf()
          .from(container)
          .set(opt)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i += 1) {
              pdf.setPage(i);
              pdf.addImage(footerImage, "PNG", 1, 297 - 35, 208, 34);
            }
            container.appendChild(footerClone);
          })
          .save();
      }
    } catch (e) {
      Message({ content: t("errors.alert"), icon: "error" });
    }
  }, [note, data, t]);

  const startDownload = useCallback(() => {
    setLoading(true);

    generateCreditNote({
      token: token,
      signal,
    })
      .then((res) => {
        setData(res.data);
        setNote(res.note);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token, signal]);

  useEffect(() => {
    generatePdf();
  }, [data, generatePdf, loading]);

  const loadStuff = useCallback(() => {
    setLoading(true);
    startDownload();
    recordPageView("credit-note", token);
  }, [startDownload, token]);

  useEffect(() => {
    loadStuff();
  }, [loadStuff]);

  return (
    <MainPage loading={loading} share={share} pageName="pdfs">
      <Row>
        <Col className="center">
          <Button type="primary" onClick={() => generatePdf()}>
            <Icon iconName="tabler/download" />
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <div id="pdfContainer" className="data" dangerouslySetInnerHTML={{ __html: data }} />
        </Col>
      </Row>
    </MainPage>
  );
};

export { CreditNote };
